import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../home.service';

@Component({
  selector: 'app-header-sort',
  templateUrl: './header-sort.component.html',
  styleUrls: ['./header-sort.component.css']
})
export class HeaderSortComponent implements OnInit {
  isLoading:boolean = false;
  userId = "";
  formId = "";
  circleId = "";
  from = "";
  isEdit:boolean = false;
  constructor(    private router: Router,
    private route: ActivatedRoute,private homeService: HomeService,private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      
      this.userId = param["userId"];
      this.formId = param["formId"];
      this.circleId = param["circleId"];
      this.from = param["from"];
      if (param) {

        this.getHeaders()
      }
    });
  }
  headerData:Array<object> = [];
  getHeaders() {
    this.isLoading = true
    let query = "?formId="+this.formId;
    this.homeService.getHeaderSortApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.headerData = res.data.headerMapping;
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.headerData, event.previousIndex, event.currentIndex);
  }

  editFn() {
    this.isEdit = !this.isEdit
  }


  putHeaderSort() {
      this.isLoading = true;
      let tempdata = this.headerData
      tempdata.forEach((x, i) => (x['sortOrder'] = i + 1));
      let finalReq = {
        formId:this.formId,
        headerMapping: tempdata
      }
      this.homeService.editHeaderSortApi(finalReq).subscribe((res) => {
        this.isLoading = false;
        if (res['message'] == 'Success') {
          this._snackBar.open("Headers sorted successfully!!","",{
            duration: 3000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['failure']
          });
          
        } else {
   this.isLoading = false;
        }
      }, err => {
        this.isLoading = false;
      });
    }

    navBack() {
      if(this.from == 'circle') {
        this.router.navigate(["/main/circles/circle-profile/circle-members"], { queryParams: { ownerId:this.userId,id:this.circleId }, preserveQueryParams: false });
      } else {
        this.router.navigate(["/main/setting/manage-forum/viewForum"]);
        
      }
      
    }

}
